import { useSelector } from 'react-redux'
import { ClientUser } from '@weblite/ts-action/client-user'
import { clientUserView } from '$logic/client-user/storage'
import {
  superUserAccountIds,
  supportAccountIds,
} from '$logic/client-user/constants'
import { isSuperUserEnabled } from './service'

export function useClientUser() {
  return useSelector(clientUserView) || ({} as ClientUser)
}

export function useIsClientUserSupport() {
  const clientUser = useClientUser()
  const isSuperUser = useIsSuperUser()
  return supportAccountIds.has(clientUser.id) || isSuperUser
}

export function useIsSuperUser() {
  const clientUser = useClientUser()
  return isSuperUserEnabled && superUserAccountIds.has(clientUser.id)
}

export function useIsClientUserSupportOrSuperUser() {
  const isSuperUser = useIsSuperUser()
  const isClientUserSupport = useIsClientUserSupport()
  return isSuperUser || isClientUserSupport
}
